import moment from 'moment';

export function formatBetween(startDate, endDate) {
	const start = moment(startDate);
	const end = moment(endDate);

	if(!start.isValid() || !end.isValid()) return '';
	else if(start.isSame(end, 'day')) return start.format('D [de] MMMM [de] YYYY')
	else if(start.isSame(end, 'month')) return `Del ${start.format('D')} al ${end.format('D [de] MMMM [de] YYYY')}`;
	else if (start.isSame(end, 'year')) return `Del ${start.format('D [de] MMMM')} al ${end.format('D [de] MMMM [de] YYYY')}`;
	else return `Del ${start.format('D [de] MMMM [de] YYYY')} al ${end.format('D [de] MMMM [de] YYYY')}`;
}

export function getDateRange(startDate, endDate) {
	const start = moment(startDate).startOf('day');
	const end = moment(endDate).startOf('day');

	if(!start.isValid() || !end.isValid() || start.isAfter(end)) return [];

	const dates = [];
	let current = start.clone();

	while(current.isSameOrBefore(end)) {
		dates.push(current.format('YYYY-MM-DD'));
		current.add(1, 'day');
	}

	return dates;
}